module.exports = __webpack_public_path__ + "static/img/card01.c6b460e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/card01.png
// module id = 272
// module chunks = 6